import React from 'react';
import CopyLogButton from '@Components/CopyLogButton';
import { Logo } from '@Components/logo';
export default class ErrorBoundary extends React.Component {
    state = {
        hasNotification: null,
        error: null,
        errorInfo: null
    };

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasNotification: true,
            error,
            errorInfo
        });
    }

    render() {
        const { children } = this.props;
        const { hasNotification, error, errorInfo } = this.state;

        if (hasNotification) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <Logo />
                    <h1>Something went wrong.</h1>
                    <p>
                        Please click the icon to copy the error and e-mail it to our support for
                        help. Reload the add-in and try again.
                    </p>
                    <CopyLogButton error={error} errorInfo={errorInfo} tooltipPlace="bottom" />
                </div>
            );
        }
        return children;
    }
}
